import { Link } from 'react-router';
import { api, ApiError } from '../../shared/api/client';
import { EmptyState, Loading } from '../../shared/ui/components';
import { useAsync } from '../../shared/ui/useAsync';
import { useMe } from '../session/SessionProvider';

/** ¿El servidor negó la salida porque la suscripción de la iglesia venció (o la iglesia está suspendida)? */
export const isLapsedError = (e: unknown) => e instanceof ApiError && e.status === 403 && (e.details?.reason === 'not_entitled' || e.details?.reason === 'church_unavailable');

/**
 * Pantallas (congregación, escenario y OBS) con la suscripción vencida: Multimedia se apaga y en
 * lugar de la proyección sale el aviso de renovación.
 */
export function LapsedScreen({ transparent = false }: { transparent?: boolean }) {
  return (
    <div className={`lapsed-screen${transparent ? ' lapsed-screen--clear' : ''}`} role="status">
      <p className="lapsed-screen__title">La suscripción de la iglesia venció</p>
      <p className="lapsed-screen__text">El administrador puede renovarla en KEORA → Facturación.</p>
    </div>
  );
}

/**
 * Consola o control sin permiso para operar: si es porque la suscripción venció lo explica (y a quien
 * paga le da el enlace a Facturación); si no, el aviso de siempre.
 */
export function CannotOperate({ churchId, fallback }: { churchId: string; fallback: string }) {
  const me = useMe();
  const standing = useAsync((signal) => api.get<{ inGoodStanding: boolean; status: string }>(`/saas/churches/${churchId}/standing`, signal), [churchId]);
  if (standing.status === 'loading') return <Loading />;
  if (standing.status === 'ready' && !standing.data.inGoodStanding) {
    return (
      <div className="lapsed-panel" role="alert">
        <h1>Multimedia está detenido</h1>
        <p>
          La suscripción de la iglesia venció y pasaron los días de gracia, así que la consola, las pantallas y el enlace de OBS no funcionan hasta renovarla. Los datos no se pierden.
        </p>
        {me.can('billing.manage') ? (
          <Link className="btn btn--primary" to="/app/facturacion">
            <span>Renovar en Facturación</span>
          </Link>
        ) : (
          <p className="muted">Pídele al pastor o a quien administra la iglesia que la renueve en KEORA → Facturación.</p>
        )}
      </div>
    );
  }
  return <EmptyState title={fallback} />;
}
